import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import Footer from "./Footer";
import AuthService from "../services/AuthService";
import { Box, Button, CssBaseline, Fab } from "@mui/material";
import NavBar2 from "../api/common/components/NavBar";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Dashboard from "../../features/home/Dashboard";
import { NotificationProvider } from "../api/common/components/NotificationContext";
import RefreshIcon from '@mui/icons-material/Refresh';

const authService = new AuthService();
interface UserData {
  // name?: string;  // The question mark means this property might be undefined
  email?: string;
}
function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [userData, setUserData] = useState<UserData | null>(null);
  const [showScroll, setShowScroll] = useState(false);
  const [themeMode, setThemeMode] = useState<'light' | 'dark'>('light');

  useEffect(() => {

    const checkScrollTop = () => {
      if (!showScroll && window.pageYOffset > 400) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 400) {
        setShowScroll(false);
      }
    };

    window.addEventListener('scroll', checkScrollTop);

    return () => {
      window.removeEventListener('scroll', checkScrollTop);
    };
  }, [location, navigate, showScroll]); // Ensure useEffect is correctly triggered

  const scrollTop = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  };

  useEffect(() => {
    
    
    if (location.pathname === "/signin-oidc") {
      authService.userManager
        .signinRedirectCallback()
        .then((user) => {
          setIsAuthenticated(true);
          setIsLoading(false);
          navigate("/"); // Redirect to home page after successful authentication
        })
        .catch((error) => {
          console.error("Error during signin callback:", error);
          setError("Error during sign-in, please try again.");
          authService.login();

          setIsLoading(false);
        });
    } else {
      authService.getUser().then((user) => {
        if (user) {
          setIsAuthenticated(true);
          setIsLoading(false);
          // Fetching user data like name, email
          authService
            .getUserData()
            .then((data) => {
              setUserData(data);
            })
            .catch((err) => {
              console.error("Error fetching user data:", err);
            });
        } else if (
          location.pathname !== "/signin-oidc" &&
          location.pathname !== "/login"
        ) {
          setIsAuthenticated(false);
          authService.login();
        } else {
          setIsLoading(false);
        }
      });
    }
  }, [location, navigate]);

  
  const logout = () => {
    authService.logout();
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;


  }
  
  const toggleTheme = () => {
    setThemeMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  const theme = createTheme({
    // Remove the 'TextareaAutosize' property from the object literal
   

    palette: {
      mode: themeMode,
      
      // primary: {
      //   light: '#e0f7fa',
      //   main: '#b2ebf2',
      //   dark: '#80deea',
      //   contrastText: '#fff',
      // },
      // secondary: {
      //   light: '#cfd8dc',
      //   main: '#b0bec5',
      //   dark: '#90a4ae',
      //   contrastText: '#000',
      // },
  
    },
  });
// ### ADDED THESE FOR NOTS 
  const handleQuickRefreshNotifications = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/dashboard/recent-activity`);
        const data = await response.json();
        
        if (data.activities && Array.isArray(data.activities)) {
            // Clear tracking to show all notifications
            localStorage.removeItem('processedNotificationIds');
            
            // You'll need to access the notification context here
            // For now, just log or use a global event
            console.log('Found', data.activities.length, 'activities');
            
            // Trigger a custom event that NotificationCenter can listen to
            window.dispatchEvent(new CustomEvent('refreshAllNotifications', {
                detail: { activities: data.activities }
            }));
        }
    } catch (error) {
        console.error('Failed to refresh notifications:', error);
    }
};
// ### ADDED THESE FOR NOTS REFRESH

  
  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <NotificationProvider>
          <NavBar2
            isAuthenticated={isAuthenticated}
            email={userData?.email}
            toggleTheme={toggleTheme}
            logout={logout}
          />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />

          <Box
            component="main"
            px={{ xs: 2, sm: 4, md: 10, lg: 20 }}
            sx={{
              marginBottom: "auto",
              overflowX: "auto",
              maxWidth: "100vw",
            }}
          >
            {location.pathname === "/" ? <Dashboard /> : <Outlet />}
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            
            <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
              <Footer />
            </Box>
          </Box>

          {/* {showScroll && ( */}
            {/* <Fab
              color="secondary"
              size="small"
              onClick={scrollTop}
              style={{ position: "fixed", bottom: "150px", right: "20px" }}
            > */}
              
              {/* <KeyboardArrowUpIcon /> */}
            {/* </Fab> */}
          {/* )} */}

        </NotificationProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
